module.exports = __webpack_public_path__ + "c540eda64c266731d0f5ede1e9b74f79.png";